export default __webpack_public_path__ + "static/media/logoHeader1.5a214669.png";